module.exports = __webpack_public_path__ + "img/atomic_habbit.06537b9f.jpg";